import O1HD, {modules, services} from "../engines/gameEngine";
import {GAME_MODE} from "../engines/managers/gameContent/gameMode_json";
import comSpSkeleton from "../engines/components/comSpSkeleton";
import {TT} from "../engines/services/i18nService";
import { PAGE, UI_Z_INDEX } from "../engines/modules/uiModule";
import normalMode from "../modes/normalMode/normalMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class hall extends cc.Component {

    @property(cc.Node)
    btnGoOn : cc.Node = null;

    onLoad() {
        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStop();
    }

    onUpdateTimer() {

    }

    started = false;

    start() {
        TT(this.node);
        let data = O1HD.getServices().localStorageSrv.getStorage("game-hours" );
        let gameHour : number = 0;
        if (data == null || data === '') {
            gameHour = 0;
        } else {
            gameHour = Number(data);
        }

        let mGameLose : number = 0;
        let mGameLoseTemp = O1HD.getServices().localStorageSrv.getStorage("game-lose");
        if (data == null || data === '') {
            mGameLose = 0;
        } else {
            mGameLose = Number(mGameLoseTemp);
        }

        if ( mGameLose == 0 && data && gameHour > 0 ) {
            this.btnGoOn.active = true;
        }

        let gameData = O1HD.getServices().localStorageSrv.getStorage( "spend-mode-data-save-key" );
        if ( gameData && gameData != "" ) {
            this.btnGoOn.active = true;
        }
        // this._test();
        // let marketPrefabNode = cc.instantiate( this.marketPrefabNode );
        // this.node.addChild( marketPrefabNode );
    }

    onBtnStart(e ,define ) {
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        if ( define == "goOn" ) {
            let gameData = O1HD.getServices().localStorageSrv.getStorage( "spend-mode-data-save-key" );
            if ( gameData && gameData != "" ) {
                O1HD.getManagers().gameMgr.selectMode(GAME_MODE.SPEND).then();
            }else{
                O1HD.getManagers().gameMgr.selectMode(GAME_MODE.NORMAL).then();
                normalMode.gameMode = define;
            }
        }else{
            O1HD.getManagers().gameMgr.selectMode(GAME_MODE.NORMAL).then();
            normalMode.gameMode = define;
        }
    }

    onBtnSpend(){
        O1HD.getManagers().gameMgr.selectMode(GAME_MODE.SPEND).then();
    }

    protected update(dt: number): void {
    }

    protected lateUpdate(dt: number) {
    }



    private _test(){
        let desc = "从未有人因为赚钱而身败名裂的";
        let actualDesc = "";
        do{
            if ( !desc ){
                break;
            }
            if ( desc.length <= 11 ){
                if ( actualDesc == "" ){
                    actualDesc += desc;
                }else{
                    actualDesc += "\n" + desc;
                }
                desc = "";
            }else{
                if ( actualDesc == "" ){
                    actualDesc += desc.slice( 0 , 10 );
                }else{
                    console.log( "1" ,desc );
                    console.log( "2" ,desc.slice( 0 , 10 ) );
                    console.log( "3" ,desc);
                    actualDesc += "\n" + desc.slice( 0 , 10 );
                }
            }
        }while ( desc.length > 0 );
        console.log("2",desc );
    }

}






























